/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Egifts {
    "use strict";
    import StorageFile = Meevo.Model.IStorageFile;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;

    export class EgiftsContext extends Meevo.Components.CommonClasses.CommonContextBase {

        public sectionsSecurityKeysBase: Array<string> = [
            this.securityKeys.MANAGEMENT_EGIFT_TAB_MAIN,
            this.securityKeys.MANAGEMENT_EGIFT_TAB_NOTIFICATIONS,
            this.securityKeys.MANAGEMENT_EGIFT_TAB_TEMPLATES,
            this.securityKeys.MANAGEMENT_EGIFT_TAB_GIFTCARDTEMPLATES,
            this.securityKeys.MANAGEMENT_EGIFT_TAB_PACKAGES,
            this.securityKeys.MANAGEMENT_EGIFT_TAB_SERVICES,
            this.securityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS,
            this.securityKeys.MANAGEMENT_EGIFT_TAB_TRANSACTIONS,
            //this.securityKeys.MANAGEMENT_EGIFT_TAB_MAILTRANSACTIONS
        ];
        
        public loadingInProgress: boolean;
        public merchantLocationId: number;
        public isFilterHidden: boolean = false;
        public isBackArrowVisible: boolean = false;
        public isCommonLocation = !this.isApplicationModeCO() && !this.isSingleLocation();
        public isModeCO = this.isApplicationModeCO();
        public isCoOrSingleLocation = this.isCoModeOrSingleLocation();
        public showSections: boolean;
        public isMsiUser: boolean = false;

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected egiftsService: Meevo.Plugins.Egifts.EgiftsService,
            protected $scope: angular.IScope,
            protected $translate: angular.translate.ITranslateService,
            protected $mdDialog: ng.material.IDialogService,
            protected $q: angular.IQService,
            protected $rootScope: ng.IRootScopeService,
            protected egiftSettings: Model.IEGiftsSettings,
            protected contextParams: Meevo.ContextParamsService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.egifts;
            this.sectionTemplatePath = "app/plugins/egifts/sectionViews/";

            //show at single location, CO and base location in case if requireClientToSelectLocation = true
            this.showSections = !this.isCommonLocation || this.egiftSettings.settings.requireClientToSelectLocation;

            this.initializeSections();
            this.isMsiUser = this.identityService.current().userTypeEnum == Meevo.Model.UserTypeEnum.MSIUser;
        }

        initializeSections(): void {
            let baseSectionProps: ISectionParamsEgifts = {
                sectionId: 0,
                displayNameContentKey: "",
                template: "",
                isPrimarySection: false,
                handlesOwnCrud: true,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: "",
                loggingService: this.loggingService,
                dataService: this.dataService,
                egiftsService: this.egiftsService,
                context: this,
                identityService: this.identityService,
                busyService: this.busyService,
                noun: Meevo.Model.NounEnum.Egift,
                sectionSecurityKey: ""
            }

            const { requireClientToSelectLocation, enableEGifts, storePickupEnable, mailEnable } = this.egiftSettings.settings;
            const eGiftEnabledForCommonLocation = this.isCommonLocation && requireClientToSelectLocation && (enableEGifts || storePickupEnable || mailEnable);
            //show at single location, CO and base location in case if requireClientToSelectLocation = true and egift is enabled
            const showSections = !this.isCommonLocation || eGiftEnabledForCommonLocation;

            const showServicesSection = !this.isCommonLocation || this.egiftSettings.settings.enableServicesCalculator || this.egiftSettings.settings.enableNewEgiftExperience;
            const showPackagesSection = !this.isCommonLocation || this.egiftSettings.settings.enablePackagesCalculator || this.egiftSettings.settings.enableNewEgiftExperience;

            if (showSections && this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(_.extend({}, baseSectionProps,
                    {
                        displayNameContentKey: "SECTION_MAIN",
                        template: "main.html",
                        isPrimarySection: true,
                        //handlesOwnCrud: false,
                        //sectionEndpoint: "settings",
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_EGIFT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        noun: Meevo.Model.NounEnum.EgiftMain
                    }), this.$q, this.appSettings.APP_TIME_FORMAT, this.egiftSettings, this.modalService));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                const defaultDeliveryMethod = DeliveryMethodEnum.EMail;
                const defaultItemType = Meevo.Plugins.Egifts.EgiftNotificationsSection.NotificationItemTypeEnum.GiftCard;
                
                this.sections.push(new NotificationsSection(_.extend({}, baseSectionProps,
                    {
                        sectionId: 1,
                        displayNameContentKey: "SECTION_EGIFTS_NOTIFICATIONS",
                        template: "notifications.html",
                        sectionEndpoint: `notification/${defaultDeliveryMethod}/${defaultItemType}`,
                        handlesOwnCrud: false,
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_EGIFT_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        noun: Meevo.Model.NounEnum.EgiftNotifications
                    }), defaultDeliveryMethod, defaultItemType, this.modalService, this.$scope, this.$translate));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_TEMPLATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new TemplatesSection(_.extend({}, baseSectionProps,
                    {
                        sectionId: 2,
                        displayNameContentKey: "SECTION_EGIFTS_TEMPLATES",
                        template: "templates.html",
                        sectionEndpoint: "template",
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_EGIFT_TAB_TEMPLATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        noun: Meevo.Model.NounEnum.EgiftTemplates
                    }), this.modalService, this.$q, this.securityChecker));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_GIFTCARDTEMPLATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new CardTemplatesSection(_.extend({}, baseSectionProps,
                    {
                        sectionId: 3,
                        displayNameContentKey: "SECTION_EGIFTS_CARD_TEMPLATES",
                        template: "cardTemplates.html",
                        sectionEndpoint: "template",
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_EGIFT_TAB_GIFTCARDTEMPLATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        noun: Meevo.Model.NounEnum.EgiftMailPickupTemplates
                    }), this.modalService, this.$q));
            }

            if (showSections && showPackagesSection && this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_PACKAGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new PackagesSection(_.extend({}, baseSectionProps,
                    {
                        sectionId: 4,
                        displayNameContentKey: "SECTION_CLIENT_PACKAGES",
                        template: "packages.html",
                        sectionEndpoint: "package",
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_EGIFT_TAB_PACKAGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        noun: Meevo.Model.NounEnum.EgiftPackages
                    })));
            }

            if (showSections && showServicesSection && this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ServicesSection(_.extend({}, baseSectionProps,
                    {
                        sectionId: 5,
                        displayNameContentKey: "SECTION_SERVICES",
                        template: "services.html",
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_EGIFT_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        noun: Meevo.Model.NounEnum.EgiftServices
                    })));
            }

            if (this.showSections && this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new PromotionsSection(_.extend({}, baseSectionProps,
                    {
                        sectionId: 6,
                        displayNameContentKey: "SECTION_CLIENT_POINT_PROMOTION_PROMOTIONS",
                        template: "promotions.html",
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        noun: Meevo.Model.NounEnum.EgiftPromoOptions
                    }), this.modalService, this.$translate, this.$scope));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_TRANSACTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new TransactionsSection(_.extend({}, baseSectionProps,
                    {
                        sectionId: 7,
                        displayNameContentKey: "SECTION_TRANSACTIONS",
                        template: "transactions.html",
                        sectionEndpoint: "GiftCard",
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_EGIFT_TAB_TRANSACTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        noun: Meevo.Model.NounEnum.EgiftTransactions
                    }), this.modalService, this.$mdDialog, this.$scope, this.$q, this.$translate, this.securityChecker, this.appSettings, this.$rootScope));

            }

            if (this.identityService.inCentralOfficeMode() || this.identityService.current().isSingleLocation) {
                this.sections.push(new EgiftsAnnouncementsSection(
                    1,
                    'Announcement',
                    'announcement.html', false, false, this.baseEndpoint, "settings", this.loggingService, this.dataService,
                    Model.NounEnum.EgiftSettingAnnouncements,
                    this.identityService, this.modalService,
                    this.securityKeys.MANAGEMENT_EGIFT_TAB_ANNOUNCEMENTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.contextParams, true
                ));
            }
            
            this.activate();

            if (this.selectedSection instanceof MainSection) {
                this.initializeMainSection(this.egiftSettings);
            }

        }

        initializeHeader() { }

        initializeMainSection(model: any): void {
            let selectedSection = <MainSection>this.selectedSection;

            if (model.settings) {
                selectedSection.modelMerchantAccountIdBackup = model.settings.paymentProcessingPreferences;
                const locationId = this.isCommonLocation ? (<any>this.identityService).identity.locationId : model.settings.locationId;
                selectedSection.getMerchantAccounts(locationId);
                selectedSection.getLocation(locationId);
                this.merchantLocationId = locationId;
            }
        }

        public buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            super.buildCrudSecurityKeysBase(baseKey, hasCreateKey, hasCopyKey);
        }

        selectSection(item): void {
            if (this.selectedSection) {
                this.selectedSection.isLoaded = false;
            }

            if (this.selectedSection instanceof TransactionsSection && this.selectedSection.isEdit) this.selectedSection.isEdit = false

            super.selectSection(item);

            let hasCreateKey = this.securityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS === this.sectionsSecurityKeysBase[item.sectionId];
            this.buildCrudSecurityKeysBase(this.sectionsSecurityKeysBase[item.sectionId], hasCreateKey);

            if (item.getData && _.isFunction(item.getData)) item.getData();
        }

        showEditLogic(): boolean {
            // Do not show Edit button on crud bar in Transactions
            if (this.selectedSection instanceof TransactionsSection) {
                return false;
            }
            if (this.selectedSection instanceof PromotionsSection) {
                return this.isReadonly && !this.selectedSection.isUndeleteMode && this.selectedSection.isShowEditButton;
            }

            return this.isReadonly;
        }

        canEditLogic(): boolean {
            if (this.securityChecker
                .hasSecurityDenyOrGrant(this.sectionsSecurityKeysBase[this.selectedSection.sectionId] +
                    Meevo.Components.Common.SecurityParts.KEY_PART_WRITE)) {
                return true;
            }

            return super.canEditLogic();
        }

        canSaveLogic(): boolean {
            return this.isEditing || this.isAdding;
        }

        canCancelLogic(): boolean {
            return this.isEditing || this.isAdding;
        }

        save(): angular.IPromise<any> {
            let selectedSection = <any>this.selectedSection;

            // Todo: Change other tabs for this way. Real nice way for custom saving
            if (this.selectedSection instanceof PromotionsSection || this.selectedSection instanceof NotificationsSection) return super.customSave();

            var templatesSection: EgiftsBaseTemplate = this.selectedSection instanceof EgiftsBaseTemplate ? this.selectedSection : null;
            if (templatesSection && (templatesSection.templateEditStatus === TemplateEditStatus.IsEditingNew || templatesSection.templateEditStatus === TemplateEditStatus.IsEditingExisting)) {
                return super.customSave();
            }

            if (selectedSection.saveData && _.isFunction(selectedSection.saveData)) {
                return selectedSection.saveData();
            }

            return super.save();
        }

        edit(): void {
            let selectedSection = <any>this.selectedSection;

            if (selectedSection.preEdit && _.isFunction(selectedSection.preEdit)) selectedSection.preEdit();

            return super.edit();
        }

        cancel(): void {
            let selectedSection = <any>this.selectedSection;

            if (selectedSection.reloadData && _.isFunction(selectedSection.reloadData)) selectedSection.reloadData();

            if(selectedSection instanceof MainSection) {
                selectedSection.cancel()
            }

            selectedSection instanceof EgiftsBaseTemplate ? selectedSection.closeEditTemplate().then(() => super.cancel()) : super.cancel();
        }

        bindTemplateImage(imageData: StorageFile, url: any): any {
            if (imageData) {
                url = this.searchFile(imageData, 'Source', url);
            }
            return url;
        }

        isScroll(): boolean {
            const infinityList = document.getElementsByTagName('md-virtual-repeat-container');
            const childrenNode = infinityList[0].firstChild;

            return (childrenNode as HTMLElement).offsetHeight < (childrenNode as HTMLElement).scrollHeight;
        }

        toggleFilter = () => {
            this.isFilterHidden = !this.isFilterHidden;
        }

        toggleBackArrow = () => {
            this.isBackArrowVisible = !this.isBackArrowVisible;
        }

        postCancel() {
            if(typeof (this.selectedSection as PromotionsSection).postCancel === 'function') {
                (this.selectedSection as PromotionsSection).postCancel()
            }
            super.postCancel();
        }
        get isAdding(): boolean {
            if (this.mode == MaintenanceFormState.Adding)
                return true;
            else
                return false;
        }

        get navigationBlocked(): boolean {  
            return this.isEditing || (this.selectedSection && this.selectedSection.isEditing) || this.isAdding;
        }

        ensureValidEgiftSettings(isPackage: boolean = false) : void {            
            const packagesEnabled = this.selectedSection.model.settings.enablePackagesCalculator;
            const amountsEnabled = this.selectedSection.model.settings.enableDollarAmountCalculator;
            const newExperienceEnabled = this.selectedSection.model.settings.enableNewEgiftExperience;
            if (!packagesEnabled && !amountsEnabled && newExperienceEnabled) {
                this.modalService.alert(this.$translate.instant('LABEL_EGIFTS_SETTINGS_WARNING'))
                .then(() => {
                    if (isPackage) {
                        this.selectedSection.model.settings.enablePackagesCalculator = true;
                    } else {
                        this.selectedSection.model.settings.enableDollarAmountCalculator = true;
                    }
                });                    
            }
        }


    }
}
